import { useSelector } from "react-redux";
import store from "src/storeWire";
import { getDocumentList, getIndividualTabsCount, } from "../store/slice/model/HomePageContent"
import HomePageContentRepository from "src/repository/HomePageContentRepository";

export function useHomePageContentStore() {
    const allTabsCount = useSelector((state) => state.entities.model_HomePageContent.allTabsCount)
    const documentContentAutosuggestList = useSelector((state) => state.entities.model_HomePageContent.documentContentAutosuggest.list)
    const documentContentList = useSelector((state) => state.entities.model_HomePageContent.documentContent.list)
    const documentContentFacets = useSelector((state) => state.entities.model_HomePageContent.documentContent.facets)
    const documentContentCount = useSelector((state) => state.entities.model_HomePageContent.documentContent.count)


    let data = {
        documentContentAutosuggestList,
        documentContentFacets,
        documentContentList,
        documentContentCount,
        allTabsCount,
    };

    let fetch = {
        get_document_list: async (params) => {
            return await store.dispatch(getDocumentList(params))
        },
        get_home_page_content: async (params) => {
            return await new HomePageContentRepository().getHomePageContent(params);
        },
        get_all_tab_count: async (params) => {
            new HomePageContentRepository().getProductTabCount(params);
            new HomePageContentRepository().getDocumentCount(params);
            new HomePageContentRepository().getContentTabsCount(params);
        },

    };
    let set = {
        set_individual_tabs_count: (name, count) => {
            return store.dispatch(getIndividualTabsCount({ [name]: count }))
        },
    };
    return [data, fetch, set]
}